/** Récupère le nom d'utilisateur Telegram lié à la licence active */
export const getLicenseTelegramUsername = (): string => {
  try {
    const savedUser = localStorage.getItem('license_user');
    if (savedUser) {
      const userData = JSON.parse(savedUser);
      const name = userData?.name?.trim();
      if (name) return name.startsWith('@') ? name : `@${name}`;
    }

    const savedLicense = localStorage.getItem('user_license');
    if (savedLicense) {
      const licenseData = JSON.parse(savedLicense);
      const username = licenseData?.username?.trim();
      if (username) return username.startsWith('@') ? username : `@${username}`;
    }
  } catch {
    /* ignore */
  }
  return '';
};

export const normalizeTelegramUsername = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return '';
  return trimmed.startsWith('@') ? trimmed : `@${trimmed}`;
};
